import React from 'react';
import styles from './Modal.module.scss';
import { IoCloseSharp } from "react-icons/io5";

/**
 * props:
 *  content: Component to display
 *  visible: true/false
 *  onClose: prop is emitted on close
 *
 *  modalonscreen prop is added to content component, indicates if component is shown. example for use in clinic\staff\Single page
 */

class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.escFunction = this.escFunction.bind(this);

        this.state = {
            settings: {
                closeMaskOnClick: ('closeMaskOnClick' in this.props) ? this.props.closeMaskOnClick : true,
                showCloseButton: ('showCloseButton' in this.props) ? this.props.showCloseButton : true,
                closeOnEsc: ('closeOnEsc' in this.props) ? this.props.closeOnEsc : true,
            },
        }

        // console.log(this.state);
    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, false);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunction, false);
    }

    escFunction(event) {
        // console.log('a', this.state.settings.closeOnEsc)
        if (!this.state.settings.closeOnEsc) {
            return;
        }
        if (event.keyCode === 27) {
            this.emitModalClose();
        }
    }

    emitModalClose() {
        if (!this.props.onClose) {
            return;
        }
        this.props.onClose();
    }

    onModalCloseHandler() {
        if (!this.state.settings.closeMaskOnClick) {
            return;
        }
        this.emitModalClose();
    }

    preventParentClick(e) {
        e.stopPropagation();
    }

    render() {

        return (
            <div>
                <div className={ `${styles.overlay} ${!!(this.props.visible) ? '' : styles.displayNone}` }
                    onClick={ () => this.onModalCloseHandler() }>
                    <div className={ `${styles.modalContainer} ${(this.props.visible ? styles.fadeIn : styles.fadeOut)}` }
                        onClick={ this.preventParentClick }
                        style={ this.props.modalContainerStyle ? this.props.modalContainerStyle : {} }>
                        {
                            this.state.settings.showCloseButton ?
                                <div className={ styles.closeButtonContainer } onClick={ () => this.onModalCloseHandler() }>
                                    <IoCloseSharp />
                                </div>
                                :
                                null
                        }

                        <div className={ styles.modal } id={ this.props.modalId ? this.props.modalId : null } style={ this.props.modalStyle ? this.props.modalStyle : {} }>
                            { React.cloneElement(this.props.content) }
                        </div>
                    </div>
                </div>


                {/*<Rodal visible={!!(this.props.visible)}*/ }
                {/*       closeOnEsc={closeOnEsc}*/ }
                {/*       showCloseButton={showCloseButton}*/ }
                {/*       closeMaskOnClick={closeMaskOnClick}*/ }

                {/*       onClose={() => this.onModalCloseHandler()}*/ }
                {/*       customStyles={{*/ }
                {/*           // display: 'flex',*/ }
                {/*           display: 'table',*/ }
                {/*           // justifyContent: 'center',*/ }
                {/*           // alignItems: 'center',*/ }
                {/*           // height: 'moz-fit-content',*/ }
                {/*           // width: 'moz-fit-content',*/ }
                {/*           // maxWidth: '100vw',*/ }
                {/*           // maxHeight: '95.5vh',*/ }
                {/*           // overflowY: 'auto',*/ }

                {/*           // padding: '35px 25px 20px 25px',*/ }
                {/*           zIndex: '1101'*/ }
                {/*       }}>*/ }
                {/*    {React.cloneElement(this.props.content,)}*/ }
                {/*</Rodal>*/ }
            </div>
        );
    }
}

export default Modal;
